import React from "react";
import { Provider } from "react-redux";
import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import ReactDOM from "react-dom/client";
import store from "./store";
import { initializeAppInsights } from "./app-insights";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
initializeAppInsights();

root.render(
	<Provider store={store}>
		<ChakraProvider value={defaultSystem}>
			<App />
		</ChakraProvider>
	</Provider>,
);